import { MantineReactTable, useMantineReactTable } from "mantine-react-table";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { FaRegHandshake } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { RiBarChartBoxLine } from "react-icons/ri";
import { ThemeContext } from "../../../../auth";
import { AgGridReact } from "ag-grid-react";
import {
  AllCommunityModule,
  ModuleRegistry,
  colorSchemeDark,
  colorSchemeLightCold,
  DateFilterModule,
  themeQuartz,
} from "ag-grid-community";
import { useMediaQuery } from "react-responsive";

function TableSalesDark({ listSales }) {
  const isMobile = useMediaQuery({ maxWidth: 736 });
  const { theme } = useContext(ThemeContext);

  const navigate = useNavigate();

  const leadButton = (row) => {
    navigate("/sales-lead", { state: { data: row } });
  };

  const dashboardButton = (row) => {
    navigate(`/dashboard-sales/${row.id}`, { state: { data: row } });
  };

  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    const dataTableFilter = listSales.map(({ ...rest }) => rest);

    setDataTable(
      dataTableFilter.map((data) => {
        return {
          ...data,
          salesName: data?.firstName + " " + data?.lastName,
          positionName: data?.role?.roleName + " " + data?.position,
        };
      }),
    );
  }, [listSales]);

  ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule]);

  const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);
  const themecolorSchemeDark = themeQuartz.withPart(colorSchemeDark);

  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (dataTable && dataTable.length > 0) {
      setRowData(dataTable);
    }
  }, [dataTable]);

  const colDefs = [
    {
      field: "dashboard",
      headerName: "Dashboard",
      sortable: true,
      width: 145,
      pinned: "left",
      cellRenderer: (row) => {
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "left",
              justifyContent: "left",
              cursor: "pointer",
            }}
            onClick={() => dashboardButton(row.data)}
          >
            <Button variant="btn" onClick={() => dashboardButton(row.data)}>
              &nbsp;
              <RiBarChartBoxLine
                className="mb-5"
                size={20}
                color={theme == "light" ? "#12B3ED" : "#006CB8"}
              />
              &nbsp;
            </Button>
          </div>
        );
      },
    },
    {
      field: "salesName",
      headerName: "Sales",
      sortable: true,
      sort: "asc",
      cellRenderer: (row) => {
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "left",
              justifyContent: "left",
              cursor: "pointer",
            }}
          >
            {row?.data?.salesName}
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      sortable: true,
      cellRenderer: (row) => {
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "left",
              justifyContent: "left",
              cursor: "pointer",
            }}
          >
            {row?.data?.email}
          </div>
        );
      },
    },
    {
      field: "positionName",
      headerName: "Posisi",
      sortable: true,
      cellRenderer: (row) => {
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "left",
              justifyContent: "left",
              cursor: "pointer",
            }}
          >
            {row?.data?.positionName}
          </div>
        );
      },
    },
    {
      field: "Lead",
      headerName: "Lead",
      width: 100,
      pinned: "right",
      cellRenderer: (row) => {
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => leadButton(row.data)}
          >
            <Button variant="btn" onClick={() => leadButton(row.data)}>
              &nbsp;
              <FaRegHandshake
                size={20}
                color={theme == "light" ? "#12B3ED" : "#006CB8"}
              />
              &nbsp;
            </Button>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true,
  };

  const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight - 200); // Adjust as needed
    };

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  // const columns = useMemo(
  //     () => [
  //         {
  //             header: 'Dashboard',
  //             accessorFn: row => (
  //                 <div >
  //                     <Button
  //                         variant='btn'
  //                         onClick={() => dashboardButton(row)}
  //                     >
  //                         &nbsp;<RiBarChartBoxLine size={20} color='#12B3ED' />&nbsp;
  //                     </Button>
  //                 </div>

  //             ),
  //             size: 50,
  //             mantineTableHeadCellProps: {
  //                 align: 'left',
  //             },
  //             mantineTableBodyCellProps: {
  //                 align: 'left',
  //             },
  //         },
  //         {

  //             header: 'Nama',
  //             accessorKey: 'salesName',
  //             mantineTableHeadCellProps: {
  //                 align: 'center',
  //             },
  //             mantineTableBodyCellProps: {
  //                 align: 'center',
  //             },

  //         },
  //         {

  //             header: 'Email',
  //             accessorKey: 'email',
  //             mantineTableHeadCellProps: {
  //                 align: 'center',
  //             },
  //             mantineTableBodyCellProps: {
  //                 align: 'center',
  //             },

  //         },
  //         {
  //             header: 'Username',
  //             accessorKey: 'username',
  //             mantineTableHeadCellProps: {
  //                 align: 'center',
  //             },
  //             mantineTableBodyCellProps: {
  //                 align: 'center',
  //             },
  //         },
  //         {
  //             header: 'Posisi',
  //             accessorKey: 'positionName',
  //             mantineTableHeadCellProps: {
  //                 align: 'center',
  //             },
  //             mantineTableBodyCellProps: {
  //                 align: 'center',
  //             },
  //         },
  //         {
  //             header: 'Lead',
  //             accessorFn: row => (
  //                 <div >
  //                     <Button
  //                         variant='btn'
  //                         onClick={() => leadButton(row)}
  //                     >
  //                         &nbsp;<FaRegHandshake size={20} color='#12B3ED' />&nbsp;
  //                     </Button>
  //                 </div>

  //             ),
  //             size: 50,
  //             mantineTableHeadCellProps: {
  //                 align: 'right',
  //             },
  //             mantineTableBodyCellProps: {
  //                 align: 'right',
  //             },
  //         },
  //     ],
  //     [],
  // );

  // const table = useMantineReactTable({
  //     columns,
  //     enableDensityToggle: false,
  //     enableFullScreenToggle: false,
  //     initialState: {
  //         density: 'xs',
  //         sorting: [
  //             {
  //                 id: 'salesName',
  //                 asc: true,
  //             },
  //         ],
  //     },
  //     data: dataTable || '',
  //     enableRowNumbers: true,
  //     rowNumberMode: 'static',
  //     isMultiSortEvent: () => true,
  //     mantineTableProps: { highlightOnHover: false }
  // });

  return (
    <div style={{ height: tableHeight }}>
      <AgGridReact
        theme={theme === "light" ? themecolorSchemeDark : themeLightCold}
        rowData={rowData}
        columnDefs={colDefs}
        defaultColDef={defaultColDef}
        pagination={isMobile ? false : true}
        rowHeight={30}
      />
    </div>
  );
}

export default TableSalesDark;
